import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  DriversIcon,
  DriversIconSelected,
  OrdersIcon,
  OrdersIconSelected,
  PriceIcon,
  PriceIconSelected,
} from "../../assets/svg";

import { cn } from "../../utils/lib";

const MENU_ITEMS = [
  {
    name: "Orders",
    to: "orders",
    Icon: <OrdersIcon />,
    SelectedIcon: <OrdersIconSelected />,
  },
  {
    name: "Drivers",
    to: "drivers",
    Icon: <DriversIcon />,
    SelectedIcon: <DriversIconSelected />,
  },
  {
    name: "Pricing",
    to: "pricings",
    Icon: <PriceIcon />,
    SelectedIcon: <PriceIconSelected />,
  },
];

export default function Sidebar({ className }) {
  const { user } = useSelector((state) => state.auth);
  const [selected, setSelected] = React.useState(MENU_ITEMS[0].name);

  return (
    <aside
      className={cn(
        "h-full min-h-screen flex-shrink-0 space-y-5 border-r border-neutral-700 bg-black pt-5 lg:w-[15.7rem]",
        className,
      )}
    >
      <Link to="/" className="col-span-2 h-fit">
        <div className="flex items-center justify-start space-x-3 px-5 py-[0.4px] 2xl:py-[0.7px]">
          <img
            src={user?.logo && user?.logo?.secure_url}
            alt="Track Limo Logo"
            className="h-10 w-10 rounded-full"
          />

          <div className="truncate text-lg font-extrabold tracking-widest text-[#f8f8f8]">
            {user?.affiliateName && user?.affiliateName.toUpperCase()}
          </div>
        </div>
      </Link>

      <div className="mx-0 mb-3 bg-gradient-to-r from-[#060606] via-[#45474c] to-[#060606] py-[0.4px] 2xl:py-[0.7px]" />

      {/* Menu Items */}
      <ul className="space-y-3 px-5 text-white">
        {MENU_ITEMS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            onClick={() => setSelected(item.name)}
          >
            <li
              className={cn(
                "my-2 flex items-center space-x-3 rounded-lg bg-black px-3 py-2.5 text-sm transition-colors hover:bg-gray-900",
                selected === item.name && "bg-[#144EE3]",
              )}
            >
              <div className="size-5">
                {selected === item.name ? item.SelectedIcon : item.Icon}
              </div>
              <h2>{item.name}</h2>
            </li>
          </Link>
        ))}
      </ul>
    </aside>
  );
}
